import React from "react";
import Title from "../../../components/Title/Title";

const FullAgenda2026page = () => {
    return (
        <div>
            <Title>Full Agenda</Title>
            <p>Below please find the schedule of the CLeaR 2026 conference. All times are in Eastern Time (ET).</p>

            <h5><font color="darkcyan">Day 1 (April 6, Monday)</font></h5>
            <table>
                <tr>
                    <b>8:00 AM-8:45 AM: Breakfast and Registration</b>
                </tr>
                <tr>
                    <b>8:45 AM-9:00 AM: Opening Remarks</b>
                </tr>
                <tr>
                    <b>9:00 AM-10:00 AM: Keynote by <a href="https://www.gatsby.ucl.ac.uk/~gretton/">Arthur Gretton</a></b>
                    <ul>
                        <li><b>Title:</b> Proxy Variables for Causal Effect Estimation with Hidden Confounding</li>
                    </ul>
                </tr>
                <tr>
                    <b>10:00 AM-10:10 AM: Coffee Break</b>
                </tr>
                <tr>
                    <b>10:10 AM-11:40 AM: Oral Session I</b>
                    <ul>
                        <li>Oral I.1. Local Markov Equivalence for PC-style Local Causal Discovery and Identification of Controlled Direct Effects</li>
                        <li>Oral I.2. Coarsening Causal DAG Models</li>
                    </ul>
                </tr>
                <tr>
                    <b>11:40 AM-12:40 PM: Lunch Break</b>
                </tr>
                <tr>
                    <b>12:40 PM-2:10 PM: Oral Session II</b>
                    <ul>
                        <li>Oral II.1. The Generalised Kernel Covariance Measure</li>
                        <li>Oral II.2. Cross-Sectional Conditional Independence in Stationary Time Series: Graphical Equivalence and Completeness of Collider Separation</li>
                    </ul>
                </tr>
                <tr>
                    <b>2:10 PM-2:20 PM: Coffee Break</b>
                </tr>
                <tr>
                    <b>2:20 PM-3:05 PM: Oral Session III</b>
                    <ul>
                        <li>Oral III.1. A Fine-Grained Look at Causal Effects in Causal Spaces</li>
                    </ul>
                </tr>
                <tr>
                    <b>3:05 PM-4:05 PM: Keynote by <a href="https://www.andrew.cmu.edu/user/kunz1/">Kun Zhang</a></b>
                    <ul>
                        <li><b>Title:</b> Causal Representation Learning and Causal Generative AI</li>
                    </ul>
                </tr>
                <tr>
                    <b>4:05 PM-6:05 PM: Poster Session I</b>
                    <ul>
                        <li>Paper ID: <b>7, 81, 27, 77, 9,</b> 43, 56, 57, 59, 61, 64, 65, 67, 70, 72, 73, 79, 80, 85, 86, 87, 90, 91, 94, 95, 97, 104</li>
                    </ul>
                </tr>
            </table>

            <br />
            <h5><font color="darkcyan">Day 2 (April 7, Tuesday)</font></h5>
            <table>
                <tr>
                    <b>8:00 AM-8:45 AM: Breakfast and Free Discussion</b>
                </tr>
                <tr>
                    <b>8:45 AM-9:45 AM: Keynote by <a href="https://ics.uci.edu/~dechter/">Rina Dechter</a></b>
                    <ul>
                        <li><b>Title:</b> Computational Aspects of Causal Inference: A Probabilistic Graphical Model Perspective</li>
                    </ul>
                </tr>
                <tr>
                    <b>9:45 AM-10:00 AM: Coffee Break</b>
                </tr>
                <tr>
                    <b>10:00 AM-11:30 AM: Panel Discussion</b>
                    <ul>
                        <li><a href="https://devavrat.mit.edu/">Devavrat Shah</a></li>
                        <li><a href="https://economics.mit.edu/people/faculty/alberto-abadie">Alberto Abadie</a></li>
                        <li><a href="https://www.carolineuhler.com/">Caroline Uhler</a></li>
                        <li><a href="https://nrhstat.org/">Niels Richard Hansen</a></li>
                        <li><a href="https://bijanmazaheri.com/">Bijan Mazaheri</a> (moderator)</li>
                    </ul>
                </tr>
                <tr>
                    <b>11:30 AM-12:15 PM: Oral Session IV</b>
                    <ul>
                        <li>Oral IV.1. Disentangling Dynamical Systems: Causal Representation Learning Meets Local Sparse Attention</li>
                    </ul>
                </tr>
                <tr>
                    <b>12:15 PM-1:45 PM: Lunch Break</b>
                </tr>
                <tr>
                    <b>1:45 PM-3:15 PM: Oral Session V</b>
                    <ul>
                        <li>Oral V.1. Automatic Debiased Machine Learning and Sensitivity Analysis for Sample Selection Models</li>
                        <li>Oral V.2. Debiased Machine Learning for Conformal Prediction of Counterfactual Outcomes Under Runtime Confounding</li>
                    </ul>
                </tr>
                <tr>
                    <b>3:15 PM-4:00 PM: Oral Session VI</b>
                    <ul>
                        <li>Oral VI.1. Intervening to Learn and Compose Causally Disentangled Representations</li>
                    </ul>
                </tr>
                <tr>
                    <b>4:00 PM-6:00 PM: Poster Session II</b>
                    <ul>
                        <li>Paper ID: <b>8, 24, 84, 88,</b> 4, 6, 11, 12, 15, 19, 20, 23, 26, 28, 29, 31, 32, 34, 35, 37, 39, 40, 48, 62, 78, 98</li>
                    </ul>
                </tr>
            </table>

            <br />
            <h5><font color="darkcyan">Day 3 (April 8, Wednesday)</font></h5>
            <table>
                <tr>
                    <b>8:00 AM-8:30 AM: Breakfast</b>
                </tr>
                <tr>
                    <b>8:30 AM-9:00 AM: Best Paper Award</b>
                </tr>
                <tr>
                    <b>9:00 AM-10:00 AM: Keynote by <a href="https://www.eogburn.com/">Betsy Ogburn</a></b>
                    <ul>
                        <li><b>Title:</b> Confounding, Dependence, and Causal Variables</li>
                    </ul>
                </tr>
                <tr>
                    <b>10:00 AM-10:15 AM: Coffee Break</b>
                </tr>
                <tr>
                    <b>10:15 AM-11:15 AM: Open Problem and Collaboration Initiation Session</b>
                </tr>
                <tr>
                    <b>11:15 AM-12:00 PM: Town Hall and Closing Remarks</b>
                </tr>
            </table>
            <br />
        </div>
    )
}

export default FullAgenda2026page;
